import React from 'react';
import Chart from './Chart';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import 'lightbox-react/style.css'; // This only needs to be imported once in your app
import { Popover, PopoverBody} from 'reactstrap';
import UserFormAndCarMenu from './carMenu/UserFormAndCarMenu';
import DescribeSavingsAmount from './DescribeSavingsAmount';
import DescribeInstallAndMonthlyFee from './DescribeInstallAndMonthlyFee';
import service from './dataService';

class SecondPart extends React.Component {

  constructor(props) {
      super(props);

      this.toggle = this.toggle.bind(this);

      this.state = {
        showSecondPart: {
          hidden: 'hidden'
        },
        lightboxIsOpen: false,
        dropdownOpen: false,
        paymentType: "Cash",
        photoIndex: 0,
        popoverOpen1: false,
        popoverOpen2: false,
        popoverOpen3: false,
        clientProfile: service.data.clientProfile,
        chartData: service.data.chartData
      };

      this.selectSystem = this.selectSystem.bind(this);
      this.selectPaymentType = this.selectPaymentType.bind(this);
      this.toggle1 = this.toggle1.bind(this);
      this.toggle2 = this.toggle2.bind(this);
      this.toggle3 = this.toggle3.bind(this);
      this.toggle4 = this.toggle4.bind(this);

      service.onValuesChanged(this.dataCenterDataChange.bind(this));
  }

  dataCenterDataChange(data) {
    this.setState({
      showSecondPart: data.showSecondPart,
      lightboxIsOpen: data.lightboxIsOpen,
      clientProfile: data.clientProfile
    });
  }

  paymentTypeRef = React.createRef();
  systemTypeRef = React.createRef();


  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  toggle1() {
    this.setState({
      popoverOpen1: !this.state.popoverOpen1
    });
  }
  toggle2() {
    this.setState({
      popoverOpen2: !this.state.popoverOpen2
    });
  }
  toggle3() {
    this.setState({
      popoverOpen3: !this.state.popoverOpen3
    });
  }
  toggle4() {
    this.setState({
      popoverOpen4: !this.state.popoverOpen4
    });
  }


  selectPaymentType(event) {
    this.setState({
      paymentType: event,
    });
    service.paymentTypeUpdater(event);
  }

  selectSystem(event) {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
    service.selectedSystemUpdater(event.target.innerText);
  }

  createCustomerEmail = (fullName, phone, email, address, zip_code, dailyTrip, mpg, year, make, model, customerSelectsSystem , testUser) => {
    console.log("SENDING CUSTOMER EMAIL")
    //console.log("customer email func: <\n>"+service.data.clientProfile.email+"<\n>");
    var emailSubject = ``;
    var emailselectionInfo ='';
    var cashorloanpayback =  Number(service.data.clientProfile.selectedSystem.payback).toPrecision(2);
  
    if(service.data.clientProfile.selectedSystem.cashorloan === "Loan"){
      cashorloanpayback = Number(service.data.clientProfile.selectedSystem.loan_payback).toPrecision(2);
    }
  
  
    if(testUser|| this.myReferer === "http://localhost:3000/"|| this.myReferer === "http://localhost:5000/" ){
        emailSubject = `Test of Customer Email- Hello from Makello`;
      }
      else{
        emailSubject = `Hello from Makello`;
      }
  
      var emailBody = '';
      if(customerSelectsSystem !== "Optimal" ){
        emailselectionInfo = `You selected the ${service.data.clientProfile.selectedSystem.system_type}* energy upgrade (${cashorloanpayback} years payback), `+
          `for as low as ${"$" + Number(service.data.clientProfile.selectedSystem.installFee).toLocaleString(navigator.language, { minimumFractionDigits: 0 })} or `+
          `$${Number(service.data.clientProfile.selectedSystem.monthly_loan_payment).toLocaleString(navigator.language, { minimumFractionDigits: 0 })}/month**.<br><br>`
      }
      else{
        emailselectionInfo = `We selected the optimal ${service.data.chartData.Optimal.system_type}* energy upgrade (${cashorloanpayback} years payback) for you, `+
          `for as low as ${"$" + Number(service.data.clientProfile.selectedSystem.installFee).toLocaleString(navigator.language, { minimumFractionDigits: 0 })} or `+
          `$${Number(service.data.clientProfile.selectedSystem.monthly_loan_payment).toLocaleString(navigator.language, { minimumFractionDigits: 0 })}/month**.<br><br>`
      }
        emailBody = `Thank you for contacting Makello!<br><br>
        
  A representative will be in touch with you soon to discuss how you can save up to ${"$" + 
  Number(service.data.clientProfile.selectedSystem.savingsAmount).toLocaleString(navigator.language,{ minimumFractionDigits: 0 })} annually with 100% Clean Energy.<br><br>
  
  ${emailselectionInfo}
  
  For more information, visit https://www.makello.com<br><br>
  
  For a FREE Energy Analysis, visit: https://www.makello.com/energy-analysis.html<br><br>

  -Cheers,<br>	
  The Makello Team<br>	
  (760) 230-3788<br>	
  Makello.com<br>	<br>

  
  *Includes highest quality: LG or Panasonic 335 watt - 400 watt solar panels, SolarEdge, SMA or Enphase IQ7+ inverter(s), balance of system and installation.<br>
  **After 50% Federal Income Tax Credit, and if loan, applied as down payment for 12 Yr Loan @ 5.49% APR. Actual APR based on credit<br><br><br>
  
  - - - - - - - - - - - - - - - <br>
  Source Page: ${this.props.campaign.MakelloPage}<br>
  Monthly Electric Bill: $${Number(service.data.clientProfile.monthlyBill).toLocaleString(navigator.language, { minimumFractionDigits: 0 })}<br>
  Email: ${email}<br>
  Full Name: ${fullName}<br>
  Phone: ${phone}<br>
  Address: ${address}<br>
  Package Selection: ${service.data.clientProfile.selectedSystem.system_type}<br>
  Payment Type: ${service.data.clientProfile.selectedSystem.cashorloan}<br>
  Daily Average Commute (miles): ${dailyTrip}<br>
  MPGe Average: ${mpg}<br>
  Plug-In Vehicle Type: ${year} ${make}, ${model}<br><br><br>
  
  ---------------------------------------------------<br>
  Optimal: ${service.data.chartData.Optimal.system_type} ${service.data.chartData.Optimal.cashorloan}<br>
  Source: ${service.data.myReferer}<br>
  Campaign: GEEPC ${this.props.campaign.name}<br><br>
  If you no longer want to receive communications, reply to unsubscribe.
    `
    fetch('../api2/nodeEmails.php', {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        to: `${email}`,
        bcc: "info@makello.com",
        subject: emailSubject,
        body:emailBody
      })
    })
    .then(response => {console.log(response)})
    .catch(error=>{console.log(error)})
  };


  render() {
    return (
      <div className={`SecondPart ${service.data.showSecondPart.hidden}`}>
      <div className='App'>
        <div className='main2'>
          <div className="row">
            <div className="col-md-8 offset-md-2">
              <div className="main2-container">
                <div className='m2Upper'>
                  <div className='m2uTextu'>
                    <p className="regular regular-fontSize">You Can Save</p>
                    <DescribeSavingsAmount system_type={service.data.clientProfile.selectedSystem.system_to_display}/>
                    <p className="regular regular-fontSize">Annually with 100% Clean Energy
                      <span className="readme" id="Popover4" onMouseOver={this.toggle4} onMouseOut={this.toggle4}>
                        &nbsp;<sup><img src="./images/info_icon.png" alt="info" style={{width:'13px', height:'13px'}}/></sup>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row"> 
            <div className="col-md-10 offset-md-1">
              <div className='m2uChart'>
                <Chart chartData={service.data.chartData} updatePaymentType={this.selectPaymentType}/>

              </div>
            </div>
          </div>

          <div className='m2uTextl text-center packagesDropdown'>

            <br />
            <DescribeInstallAndMonthlyFee system_type={service.data.clientProfile.selectedSystem.system_to_display} />
            <ButtonDropdown direction="right" isOpen={this.state.dropdownOpen} toggle={this.toggle}>
              <DropdownToggle caret>
                {service.data.clientProfile.selectedSystem.system_to_display}
                {/* {this.state.value} */}
              </DropdownToggle>
              <DropdownMenu>
              {['Optimal', 'Economy', 'Compact', 'Intermediate', 'Standard', 'Premium', 'Plug-In Vehicle', 'Solar + Plug-In Vehicle'].map((item, index) => (<DropdownItem key={index} onClick={this.selectSystem}>{item}</DropdownItem>))}
              </DropdownMenu>
            </ButtonDropdown>
          </div>
          <div className="m2uTextl-small text-center deactive-color">
            <h6>Includes highest quality LG 335w - 400w solar panels; SolarEdge, SMA or Enphase inverter(s); balance of system & installation.</h6>
            <h6>*After 50% Federal ITC, and if loan, applied as down payment on 12 Yr Loan @ 5.49% APR (based on credit).</h6>
          </div>
          
          <UserFormAndCarMenu payment_type = {this.state.paymentType} monthlyBill={service.data.clientProfile.monthlyBill} createCustomerEmail={this.createCustomerEmail}
 campaign = {this.props.campaign}/>
 
         </div>

         <section className="payback">
               <div className="row">
                <div className="col-lg-6">

                  <div className="paybackWrapper">
                    <h2 className="payback-heading">High Energy Bill? <span className="text-muted">No Problem!</span></h2>
                    <div className="mt-3">
                      Enter your email above, for a Coupon Code that includes: 
                      <ul>
                        <li>Free Energy Analysis <span className="readme" id="Popover3" onMouseOver={this.toggle3} onMouseOut={this.toggle3}>
                      &nbsp;<sup><img src="./images/info_icon.png" alt="info" style={{width:'13px', height:'13px'}}/></sup></span></li>
                        <li>Simple payback in 1 - 3 years <span className="readme" id="Popover1" onMouseOver={this.toggle1} onMouseOut={this.toggle1}>
                      &nbsp;<sup><img src="./images/info_icon.png" alt="info" style={{width:'13px', height:'13px'}}/></sup></span></li>
                        <li>Systems starting at $5,599 or $53/mo.<span className="readme" id="Popover2" onMouseOver={this.toggle2}
                      onMouseOut={this.toggle2}>&nbsp;<sup> <img src="./images/info_icon.png" alt="info" style={{width:'13px', height:'13px'}}/></sup>
                      </span></li>
                      </ul>
                    </div>

                    <div className="mt-4"></div>
                  </div>
                </div>

                <div className="col-lg-6">

                	<div className="surveyVid">
	                	<div className="embed-responsive embed-responsive-16by9">
      
                        <iframe className="embed-responsive-item" title="makello_video"  frameBorder="0" src={this.props.campaign.Video} allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
	                	</div>
                	</div>

                </div>
              </div>
              <Popover placement="auto" isOpen={this.state.popoverOpen1} target="Popover1" toggle={this.toggle1}>
                <PopoverBody><div className="payback-disclaimer">
                    Simple Payback in 1-3 years is possible for SDGE
                    annual electric utility bills on the Standard Domestic Rate, and ineligible
                    for Medical & Low Income discounts.
                    Actual time to Simple Payback depends on Time-Of-Use interval data for electric
                    consumption, and solar PV production variables.
                  </div></PopoverBody>
              </Popover>

              <Popover placement="auto" isOpen={this.state.popoverOpen2} target="Popover2" toggle={this.toggle2}>
                <PopoverBody><div className="payback-disclaimer">
                  Includes highest quality: LG 335 watt - 400 watt solar panels, SolarEdge, SMA or Enphase IQ7 inverter(s), balance of system and installation. After 50% Federal Income Tax Credit, and if loan, applied as downpayment for 12 Yr Loan @ 5.49% APR. Actual APR based on credit application.
                  </div></PopoverBody>
              </Popover>
              <Popover placement="auto" isOpen={this.state.popoverOpen3} target="Popover3" toggle={this.toggle3}>
                <PopoverBody><div className="payback-disclaimer">
                Makello's Energy Analysis includes:<br></br>

                  &nbsp;&nbsp; -Site survey<br></br>
                  &nbsp;&nbsp; -Shading analysis<br></br>
                  &nbsp;&nbsp; -Cash flow analysis<br></br>
                  &nbsp;&nbsp; -Trade-off study<br></br>
                  &nbsp;&nbsp; -Custom proposal<br></br>
                  <br></br>

                  SDG&E and Home Energy Auditors typically charge between $400-$800.
                  Enter your email in the form above to receive a FREE Energy Analysis by our Ethical Energy Efficiency Experts, and a comprehensive report.
                  You may also request access to site survey measurements, shading analysis, and pictures.
                  </div></PopoverBody>
              </Popover> 
              <Popover placement="auto" isOpen={this.state.popoverOpen4} target="Popover4" toggle={this.toggle4}>
                <PopoverBody><div className="payback-disclaimer">
                  Your monthly electric bill matches 100's of customer case studies! Each package includes ALL of your annual electricity from renewable sources only.
                  </div></PopoverBody>
              </Popover>


            </section>

      </div>
      </div>
    );
  }
}
   

export default SecondPart;